<mat-icon color="primary" matTooltip="{{ state }}">
  {{ mapStateToIcon(state) }}
</mat-icon>
